export const NAME = 'disputes';

export const DESCRIPTION_MAX_LENGTH = 500;
